const theme = {
  token: {
    colorPrimary: "#2C2E2D",
    borderRadius: "10px",
    colorText: "#fff",
  },
};

export default theme;
